import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  submittedBillsDetails: {
    id: number;
    claimId: number;
    fileName: string;
    extension: string;
    fileSize: number;
    uploadDate: string;
  }[];
  loading: boolean;
  error: boolean;
  submitted: boolean;
  errorMessage: string;
} = {
  loading: false,
  error: false,
  submitted: false,
  submittedBillsDetails: [],
  errorMessage: "",
};
const submitBills = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_BALANCEBILLS_STARTED:
      return updateObject(state, {
        loading: true,
        error: false,
        submitted: false,
        errorMessage: initialState.errorMessage,
        submittedBillsDetails: initialState.submittedBillsDetails,
      });
    case actionTypes.SUBMIT_BALANCEBILLS_FAILED: {
      return updateObject(state, {
        loading: false,
        error: true,
        errorMessage: action.payload,
        submitted: false,
        submittedBillsDetails: initialState.submittedBillsDetails,
      });
    }
    case actionTypes.SUBMIT_BALANCEBILLS_SUCCESS: {
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: true,
        errorMessage: initialState.errorMessage,
        submittedBillsDetails: action.submittedBillsDetails,
      });
    }
    case actionTypes.RESET_SUBMIT_BALANCEBILLS: {
      return updateObject(state, {
        loading: false,
        error: false,
        submitted: false,
        submittedBillsDetails: [],
        errorMessage: "",
      });
    }
    default:
      return state;
  }
};
export default submitBills;
